import { render, staticRenderFns } from "./SimpleTextareaForm.vue?vue&type=template&id=5179eec5&scoped=true&"
import script from "./SimpleTextareaForm.vue?vue&type=script&lang=js&"
export * from "./SimpleTextareaForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextareaForm.vue?vue&type=style&index=0&id=5179eec5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179eec5",
  null
  
)

export default component.exports